export function combineIds(
  ...ids: (string | number | undefined | null)[]
): string | undefined {
  const combinedId = ids
    .filter(id => id || typeof id === 'number')
    .join('-');

  return combinedId || undefined;
}
